import React, {Component} from "react";
import axios from "axios";
import Loading from "../Loading";
import {connect} from "react-redux";
import AccessDeny from "../AccessDeny";
import DayPickerInput from "react-day-picker/DayPickerInput";
import MomentLocaleUtils, {formatDate, parseDate} from "react-day-picker/moment";
import BPHDBReportPolicyPendingRow from "./BPHDBReportPolicyPendingRow";

class BPHDBReportPolicyPending extends Component{
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            errorMessage: '',
            items: [],
            rows: [],
            selectedFromDay: undefined,
            isFromDayEmpty: true,
            isFromDayValid: false,
            isFromDayDisabled: false,
            selectedToDay: undefined,
            isToDayEmpty: true,
            isToDayValid: false,
            isToDayDisabled: false,
            policyNumber: '',
            itemPerPage: 200,
            totalPages: 0,
            currentPage: 1
        }
        this.renderRows = this.renderRows.bind(this);
        this.handleClickPreviousButton = this.handleClickPreviousButton.bind(this);
        this.handleClickNextButton = this.handleClickNextButton.bind(this);
        this.handleChangeItemPerPage = this.handleChangeItemPerPage.bind(this);
        this.handleFromDayChange = this.handleFromDayChange.bind(this);
        this.handleToDayChange = this.handleToDayChange.bind(this);
        this.handleChangePolicyNumber = this.handleChangePolicyNumber.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        let today = new Date();
        let toDate = new Date();
        let fromDate = new Date();
        fromDate.setDate(today.getDate() - 1);
        fromDate.setMonth(fromDate.getMonth() - 2);
        toDate.setDate(today.getDate() - 1);
        this.setState({
            selectedFromDay: fromDate,
            isFromDayEmpty: false,
            isFromDayValidDay: true,
            selectedToDay: toDate,
            isToDayEmpty: false,
            isToDayValidDay: true,
        });
    }

    renderRows = (items,itemPerPage,currentPage) =>{
        const prevPage = currentPage - 1;
        const rows = items?.slice(prevPage  * itemPerPage, currentPage * itemPerPage);
        console.log('row size:'+rows.length)
        const totalPages = Math.floor((items || []).length / itemPerPage + 1)
        this.setState({items:items, rows: rows, totalPages: totalPages,errorMessage:'',isLoading: false});
    }

    handleChangeItemPerPage(e){
        const {items} = this.state;
        this.setState({currentPage: 1, itemPerPage: e.target.value, totalPages: Math.floor((this.state.items || []).length / e.target.value + 1)});
        this.renderRows(items,e.target.value, 1);
    }
    handleClickPreviousButton() {
        const {items,itemPerPage,currentPage} = this.state
        const prevPage = currentPage - 1
        if(prevPage > 0){
            this.setState({currentPage: prevPage})
            this.renderRows(items,itemPerPage,prevPage);
        }
    }
    handleClickNextButton() {
        const {items,itemPerPage,currentPage,totalPages} = this.state
        const nextPage = currentPage + 1
        if(nextPage <= totalPages){
            this.setState({currentPage: nextPage});
            this.renderRows(items,itemPerPage,nextPage);
        }
    }

    handleFromDayChange = (selectedFromDay, modifiers, dayPickerInput) =>{
        const input = dayPickerInput.getInput();
        this.setState({
            selectedFromDay,
            isFromDayEmpty: !input.value.trim(),
            isFromDayValidDay: typeof selectedDay !== 'undefined',
            isFromDayDisabled: modifiers.disabled === true
        });
    }

    handleToDayChange = (selectedToDay, modifiers, dayPickerInput) =>{
        const input = dayPickerInput.getInput();
        this.setState({
            selectedToDay,
            isToDayEmpty: !input.value.trim(),
            isToDayValidDay: typeof selectedDay !== 'undefined',
            isToDayDisabled: modifiers.disabled === true
        });
    }

    handleChangePolicyNumber = (e) =>{
        this.setState({policyNumber: e.target.value});
    }
    handleSubmit = () =>{
        const { selectedFromDay, selectedToDay, policyNumber, isFromDayEmpty, isFromDayValid, isToDayEmpty, isToDayValid } = this.state;
        if(isFromDayEmpty){
            this.setState({errorMessage: 'Vui lòng chọn ngày bắt đầu tìm kiếm!'})
            return;
        }
        if(isFromDayValid){
            this.setState({errorMessage: 'Ngày bắt đầu không hợp lệ!'})
            return;
        }
        if(isToDayEmpty){
            this.setState({errorMessage: 'Vui lòng chọn ngày kết thúc tìm kiếm!'})
            return;
        }
        if(isToDayValid){
            this.setState({errorMessage: 'Ngày kết thúc không hợp lệ!'})
            return;
        }
        if(this.diffMonth(selectedFromDay, selectedToDay) > 2){
            this.setState({errorMessage: 'Chỉ được phép tìm kiếm dữ liệu trong khoảng thời gian 2 tháng!'})
            return;
        }
        const fromDate = formatDate(selectedFromDay, 'DD/MM/YYYY');
        const toDate = formatDate(selectedToDay, 'DD/MM/YYYY');
        const formData = new FormData();
        formData.append('fromDate',fromDate);
        formData.append('toDate',toDate);
        formData.append('policyNumber', policyNumber);
        this.setState({ isLoading: true })
        axios.post('/api/bankportal/report/hdb/policy/pending', formData)
            .then(response =>{
                this.renderRows(response.data?.hdbSaleReports,200,1)
            })
            .catch(error =>{
                console.error('Error search!', error)
                this.setState({items: [], errorMessage: error.message, successMessage:'', isLoading: false})
            })
    }
    diffMonth = (startDate, endDate) => {
        let months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
        months += (endDate.getMonth() - startDate.getMonth()) + 1;
        if(endDate.getDate() <= startDate.getDate()){
            months --;
        }
        return months;
    }
    render(){
        const { isLoading,errorMessage,items, rows,totalPages,currentPage,itemPerPage,selectedFromDay,selectedToDay } = this.state;
        if(!this.props.isRoleReport && !this.props.isRoleHO) return <AccessDeny />
        const renderPreviousButton = () => {
            if(currentPage <= 1) return null;
            return(
                <a className='text-primary bp-paging-link' onClick={this.handleClickPreviousButton} > {'<< '}Trước</a>
            )
        }
        const renderNextButton = () => {
            if(currentPage >= totalPages) return null;
            return (
                <a className='text-primary bp-paging-link' onClick={this.handleClickNextButton}>Sau {' >>'}</a>
            )
        }
        const renderItemPerPage = () => {
            return (
                <div className='input-group'>
                    <label className='input-group-text bg-white border-0 font-weight-bold'>Số hàng mỗi trang</label>
                    <select value={itemPerPage} onChange={this.handleChangeItemPerPage} className='form-control'>
                        <option>100</option>
                        <option>200</option>
                        <option>500</option>
                        <option>1000</option>
                        <option>5000</option>
                        <option>10000</option>
                    </select>
                </div>
            )
        }
        const renderPageIndex = () => {
            if(totalPages <= 0) return null;
            return(<span>Trang {currentPage} / {totalPages}</span>)
        }
        const renderPaging = () => {
            return (
                <div className='d-flex justify-content-between align-items-center'>
                        <div>{renderPreviousButton()}</div>
                        <div>{renderItemPerPage()}</div>
                        <div>{renderPageIndex()}</div>
                        <div>{renderNextButton()}</div>
                </div>
            )
        }
        return(
            <div className={'ml-2 mb-2'}>
                { isLoading && <Loading /> }
                <div className={'mt-2'}>
                    <h2 className={'hdb-text-color mb-3'}>Báo cáo Hợp đồng bảo hiểm chưa giải quyết - HDBank</h2>
                    <form>
                        <div className={'form-group row'}>
                            <label className={'control-label mb-2 mr-sm-2 hdb-text-color mt-2 ml-3'}>Chọn ngày nộp HSYCBH :</label>
                            <label className="control-label mb-2 mr-sm-2 hdb-text-color mt-2">Từ</label>
                            <div className={'mb-2 mr-sm-2'}>
                                <DayPickerInput
                                    value={selectedFromDay}
                                    onDayChange={this.handleFromDayChange}
                                    selectedDay={this.state.selectedFromDay}
                                    formatDate={formatDate}
                                    parseDate={parseDate}
                                    format="DD/MM/YYYY"
                                    placeholder='DD/MM/YYYY'
                                    dayPickerProps={{
                                        selectedDays: selectedFromDay,
                                        locale: 'vi-VN',
                                        localeUtils: MomentLocaleUtils,
                                    }}
                                    inputProps={{ className: 'form-control' }}
                                />
                            </div>
                            <label className="control-label mb-2 mr-sm-2 hdb-text-color mt-2">Đến</label>
                            <div className={'mb-2 mr-sm-2'}>
                                <DayPickerInput
                                    value={selectedToDay}
                                    onDayChange={this.handleToDayChange}
                                    selectedDay={this.state.selectedToDay}
                                    formatDate={formatDate}
                                    parseDate={parseDate}
                                    format="DD/MM/YYYY"
                                    placeholder='DD/MM/YYYY'
                                    dayPickerProps={{
                                        selectedDays: selectedToDay,
                                        locale: 'vi-VN',
                                        localeUtils: MomentLocaleUtils,
                                    }}
                                    inputProps={{ className: 'form-control' }}
                                />
                            </div>
                            <label className="control-label mb-2 mr-sm-2 hdb-text-color mt-2">Số hợp đồng bảo hiểm :</label>
                            <div className={'mb-2 mr-sm-2'}><input type={'text'} className={'form-control'} onChange={this.handleChangePolicyNumber}></input></div>
                            <button type='button' className={'btn btn-warning btn mb-2 font-weight-bold'} onClick={this.handleSubmit} >Xem báo cáo</button>
                        </div>
                    </form>
                </div>
                <div className="text-danger">Lưu ý: chỉ được phép tìm kiếm dữ liệu trong khoảng thời gian 2 tháng</div>
                <div className={'mb-2'}><label className="control-label mb-2 mr-sm-2 hdb-text-color">Tổng kết quả tìm được:</label> <span className={'btn btn-info'}>{items?.length}</span></div>
                { !!errorMessage && <div className={"alert alert-warning"} role="alert">{ errorMessage }</div> }
                <table className={'table table-striped table-bordered w-auto small hdb-table'}>
                    <thead>
                    <tr>
                        <th>STT</th>
                        <th>Tên AL</th>
                        <th>Tên DOB</th>
                        <th>Mã số Cán bộ ngân hàng</th>
                        <th>Tên Cán bộ ngân hàng</th>
                        <th>Loại tư vấn</th>
                        <th>Khu vực</th>
                        <th>Cụm Chi nhánh/Phòng giao dịch</th>
                        <th>Mã Chi nhánh/Phòng giao dịch</th>
                        <th>Tên Chi nhánh/Phòng giao dịch</th>
                        <th>Số Hồ sơ yêu cầu bảo hiểm</th>
                        <th>Số Hợp đồng bảo hiểm</th>
                        <th>Ngày nhận Hồ sơ yêu cầu bảo hiểm</th>
                        <th>Tình trạng Hợp đồng</th>
                        <th>Người được bảo hiểm chính</th>
                        <th>Phí bảo hiểm năm</th>
                        <th>Phí bảo hiểm định kỳ</th>
                        <th>Định kỳ đóng phí</th>
                        <th>Loại sản phẩm</th>
                        <th>Kênh</th>
                        <th>Ngày báo cáo</th>
                    </tr>
                    </thead>
                    <tbody>
                        {!!rows && rows.map((item, index) => <BPHDBReportPolicyPendingRow key={item?.id} item={item} index={index+((currentPage - 1) * itemPerPage)} />)}
                    </tbody>
                </table>
                {renderPaging()}
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    const authorities = state?.auth?.authorities;
    const isRoleHO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_HO');
    const isRoleFWDContest = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BP_CONTEST');
    const isRoleBO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BO');
    const isRoleTO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_TO');
    const isRoleReport = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BP_REPORT');
    const username = state?.auth?.name;
    return { username,isRoleHO, isRoleFWDContest, isRoleBO, isRoleTO, isRoleReport };
};

export default connect(mapStateToProps)(BPHDBReportPolicyPending);